var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoArquivoEntrada01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    d: "M21.5,14.7h-7V20H9.3l8.7,8.7l8.7-8.7h-5.2V14.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    d: "M31.9,34.6H4.1c-1.9,0-3.5-1.6-3.5-3.5V10.2c0-0.4,0.1-0.7,0.4-1l0,0l5.2-7C6.5,1.7,7,1.4,7.5,1.4h20.9 c0.5,0,1.1,0.3,1.4,0.7l5.2,7l0,0c0.2,0.3,0.4,0.7,0.4,1v20.9C35.4,33,33.9,34.6,31.9,34.6z M4.1,11.9v19.2h27.9V11.9H4.1z M8.4,4.9 L5.8,8.4h24.4l-2.6-3.5H8.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArquivoEntrada01);
export default __webpack_public_path__ + "static/media/ico-arquivo-entrada-01.0908bfbebe74fcbbb07a0d5ea827ba0a.svg";
export { ForwardRef as ReactComponent };